import React, { useEffect, useMemo, useState, useContext } from 'react';

import { HeaderContainer, HeaderLinks, Hlink, TitleDiv, IconDiv, EICol, HliItem, TitleHeader, HulContainer, BtnDeconnexion } from './Header.styled';
import logoAdmin from '../../assets/images/Logo-Younov.png';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { CTooltip } from '../../components/UI/CTooltip/CTooltip';
import { getNotyfObject } from '../../shared/utility';
import { useAuthUser } from "../../api/auth";
import HelpIcon from '@mui/icons-material/Help';
import { BsFilePdf } from "react-icons/bs";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import PdfViewer from '../../components/PdfViewer/PdfViewer'
function Header(props) {
    const { logout, login, setAppTheme, currentTheme, userType, logoutUrl, URL, logo, isEnqueteSatisfaction } = props;
    const [playing, setPlaying] = useState(false);
    const location = useLocation();
    let notyf = getNotyfObject();
    /*const { isLoggedIn, username, logoutUrl, isLoading } = useAuthUser();*/
    const [confirmationGuideModalShow, setConfirmationGuideModalShow] = useState(false)

    //console.log(logo)

    const showGuid = (typeGuide) => {
        const baseUrl = window.location.origin;
        if (typeGuide == "guidTd")
            window.open(baseUrl + '/showGuideTeledeclaration', '_blank');
        if (typeGuide == "guidProduction")
            window.open(baseUrl + '/showGuideProduction', '_blank');
    }

    const headerImg = useMemo(() => (
        <>
            <TitleDiv isLocataire={userType == "LOCATAIRE"}>
                <img
                    style={{
                        height: "40px",
                        marginRight: "3%",
                        marginTop: "7px",
                        "objectFit": "contain"
                    }}

                    src={logo != null ? `${import.meta.env.VITE_CDN_LOGO_BAS_URL}/${logo}` : logoAdmin} />
                    {userType == "ADMIN_YOUNOV" ?
                    <TitleHeader>BackOffice Enquêtes OPS/SLS</TitleHeader>
                    :
                    isEnqueteSatisfaction ? <TitleHeader>Enquête satisfaction</TitleHeader> :<TitleHeader>Enquêtes OPS/SLS</TitleHeader>
                }
            </TitleDiv>
        </>
    ), [logo])


    const help = useMemo(() => (
        <>
            <IconDiv>
                <HelpIcon style={{ fontSize: "2.3rem", color: "#49c633", }} />
                <EICol >
                    <HulContainer>
                        <HliItem>
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", }}>

                                <BsFilePdf />
                                <a target="_blank" onClick={() => { showGuid("guidProduction") }}>Afficher le guide de suivi de production</a>

                            </div>
                        </HliItem>
                        <HliItem>
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", }}>

                                <BsFilePdf />
                                <a target="_blank" onClick={() => { showGuid("guidTd") }}>Afficher le guide de télédéclaration</a>

                            </div>
                        </HliItem>
                    </HulContainer>
                </EICol>
            </IconDiv>
        </>

    ), [])
    async function logOut() {
        window.location.href = logoutUrl;
    }
    console.log(userType)
    return (
        <>
            <HeaderContainer>
                {headerImg}
                {userType!= "LOCATAIRE" &&
                    <HeaderLinks>
                        <Hlink
                            color={"#EE5A5A"}
                            onClick={() => logOut()}
                        >
                            <BtnDeconnexion>
                                Déconnexion
                            </BtnDeconnexion>
                        </Hlink>
                        {help}
                    </HeaderLinks>
                }
            </HeaderContainer>

            {/*
                <VideoPlayer playing={playing} setPlaying={setPlaying} />
              */}
            <PdfViewer
                show={confirmationGuideModalShow}
                closeModal={setConfirmationGuideModalShow}
                title={"lire le guide"}
            />

        </>
    );
}

const mapStateToProps = state => {
    return {
        currentTheme: state.app.theme,
        isAuthenticated: state.auth.token !== null,
        login: state.auth.login,
        userType: state.auth.userType,
        logoutUrl: state.auth.logoutUrl,
        logo: state.auth.logo,
        URL: state.auth.URL,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setAppTheme: (theme) => dispatch(actions.appSetTheme(theme)),
        onAuth: (email, password) => dispatch(actions.auth(email, password)),
        onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/')),
        logout: () => dispatch(actions.logout())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
